<template>
    <v-card elevation="1">
        <div>
            <v-card class="custom-table-ui header-filters pa-3" flat>
                <v-row>
                    <v-col md="3" lg="3" cols="12" class="mr-auto">
                        <v-text-field v-model="dataTable.search" label="Search here" placeholder="Search here" prepend-inner-icon="search" solo dense flat color="primaryTextColor" clearable hide-details />
                    </v-col>
                    <!-- <v-col md="3" lg="2" cols="12">
                        <v-select
                            v-model="dataTable.merchant_type"
                            :items="[{ text: 'All Merchant Type', value: 'all' }, { divider: true }, { text: 'Partner', value: 'partner' }, { text: 'Branches', value: 'branches' }]"
                            item-text="text"
                            item-value="value"
                            label="Select merchant type"
                            placeholder="Select merchant type"
                            solo
                            flat
                            dense
                            outlined
                            required
                            hide-details
                        ></v-select>
                    </v-col>
                    <v-col md="3" lg="2" cols="12">
                        <v-select
                            v-model="dataTable.batch_number"
                            :items="[{ text: 'All Batch Number', value: 'all' }, { divider: true }, { text: '00001', value: '00001' }, { text: '00002', value: '00002' }]"
                            item-text="text"
                            item-value="value"
                            label="Select batch number"
                            placeholder="Select batch number"
                            solo
                            flat
                            dense
                            outlined
                            required
                            hide-details
                        ></v-select>
                    </v-col>
                    <v-col md="3" lg="2" cols="12">
                        <v-select
                            v-model="dataTable.min_points"
                            :items="[{ text: 'Minimum Points', value: 'all' }, { divider: true }, { text: '00001', value: '00001' }, { text: '00002', value: '00002' }]"
                            item-text="text"
                            item-value="value"
                            label="Select minimum points"
                            placeholder="Select minimum points"
                            solo
                            flat
                            dense
                            outlined
                            hide-details
                        ></v-select>
                    </v-col> -->
                </v-row>
            </v-card>
            <v-divider></v-divider>
            <v-card v-if="dataTable.selected.length" flat class="download-selected pa-4 d-flex">
                <b class="success--text my-auto">{{ dataTable.selected.length }} Selected QR</b>

                <v-btn class="ml-auto" color="success" @click="download"> <v-icon left> mdi-tray-arrow-down </v-icon> Download Selected</v-btn>
            </v-card>
            <v-data-table
                class="custom-table-ui no-loading-bar"
                v-model="dataTable.selected"
                item-key="_id"
                :headers="dataTable.headers"
                :items="dataTable.data"
                :loading="dataTable.loading"
                loader-height="0"
                loading-text="Loading data..."
                :page.sync="dataTable.currentPage"
                :items-per-page.sync="dataTable.itemLength"
                :sort-by.sync="dataTable.sortBy"
                :sort-desc.sync="dataTable.sortDesc"
                :custom-sort="(items) => items"
                hide-default-footer
            >
                <template v-slot:[`header.min_points`]="{ header }">
                    {{ header.text }}
                    <v-tooltip bottom max-width="160px">
                        <template v-slot:activator="{ on }">
                            <v-icon v-on="on" small>mdi-alert-circle-outline</v-icon>
                        </template>

                        <div class="tooltip-wrapper">
                            <span>{{ header.tooltip }}</span>
                        </div>
                    </v-tooltip>
                </template>

                <template v-slot:[`item.status`]="{ item }">
                    <div :class="['status', item.status]">{{ item.status }}</div>
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                    <div class="action">
                        <v-menu min-width="160px">
                            <template v-slot:activator="{ on: menu, attrs }">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on: tooltip }">
                                        <v-icon class="mr-2" v-bind="attrs" v-on="{ ...tooltip, ...menu }">mdi-dots-vertical</v-icon>
                                    </template>
                                    <span>More</span>
                                </v-tooltip>
                            </template>

                            <v-list>
                                <v-list-item dense @click="viewDetails(item.id)">View Details</v-list-item>
                                <v-list-item dense @click="editDetails(item.id)">Edit Details</v-list-item>
                            </v-list>
                        </v-menu>
                    </div>
                </template>
            </v-data-table>

            <v-card class="data-table-footer d-flex align-center justify-space-between flex-wrap border-radius-10 py-0" flat color="primaryBackgroundColor">
                <div class="flex-md-grow-0 flex-sm-grow-0 flex-grow-1 d-flex align-center justify-center py-2 px-3">
                    <span>Show</span>
                    <v-select class="item-length mx-2" v-model="dataTable.itemLength" :items="[10, 20, 50, 100]" solo dense flat background-color="secondaryBackgroundColor" hide-details />
                    <span class="px-0" md="auto" sm="auto" cols="auto">items per page</span>
                </div>
                <v-pagination class="flex-md-grow-0 flex-sm-grow-0 flex-grow-1 justify-center py-2" v-model="dataTable.currentPage" :length="dataTable.totalPages" :total-visible="7"></v-pagination>
            </v-card>
        </div>
        <!-- <div v-else class="merchant-empty text-center">
            <div>
                <div class="mt-n9" v-html="require(`!html-loader!@/assets/img/cart.svg`)"></div>
                <div class="font-weight-bold">There are no Merchants to display.</div>
                <small>You’ve not added any merchant yet.</small>
            </div>
        </div> -->
    </v-card>
</template>

<script>
export default {
    name: 'SystemVariablesDataTable',
    props: {
        details: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            dataTable: {
                loading: true,
                search: '',
                merchant_type: 'all',
                batch_number: 'all',
                itemLength: 10,
                currentPage: 1,
                totalPages: 1,
                selected: [],
                sortBy: [],
                sortDesc: [],
                headers: [
                    { text: 'Variable', value: 'key' },
                    { text: 'Value', value: 'value' },
                    { text: 'Description', value: 'description' },
                    { text: 'Status', value: 'status' },
                    // { text: 'Date Created', value: 'created_at' },

                    {
                        text: '',
                        value: 'actions',
                        sortable: false,
                        class: ['sticky', 'right'],
                        cellClass: ['sticky', 'right']
                    }
                ],
                // data: [] || undefined,
                data: []
            }
        };
    },
    computed: {
        list() {
            return this.$store.getters['systemVariables/getSystemVariablesList'];
        }
        // siteItems() {
        //     let sites = this.$store.getters['options/getSitesDropdown'],
        //         list = [];
        //     if (sites && Array.isArray(sites)) {
        //         sites.forEach((site) => {
        //             list = [...list, { text: site.name, value: site.id }];
        //         });
        //     }
        //     return list;
        // }
    },

    watch: {
        list(to) {
            if (to) {
                this.dataTable.loading = false;
                this.dataTable.totalPages = to.meta.last_page;
                this.dataTable.data = to.data; // to.data

                window.scrollTo(0, 0);
            }
        },
        'dataTable.itemLength'() {
            this.dataTable.currentPage = 1;
            this.getData({ cancel_current_api_call: true });
        },
        'dataTable.currentPage'() {
            this.getData({ cancel_current_api_call: true });
        },
        'dataTable.sortBy'() {
            const sortBy = this.dataTable.sortBy[0],
                sortDesc = this.dataTable.sortDesc[0];

            if (sortBy != undefined && sortDesc != undefined && sortDesc != true) {
                this.getData({ cancel_current_api_call: true });
            } else if (sortBy == undefined && sortDesc == undefined) {
                this.getData({ cancel_current_api_call: true });
            }
        },
        'dataTable.sortDesc'() {
            const sortBy = this.dataTable.sortBy[0],
                sortDesc = this.dataTable.sortDesc[0];

            if (sortBy != undefined && sortDesc != undefined) {
                this.getData({ cancel_current_api_call: true });
            } else if (sortBy == undefined && sortDesc == undefined) {
                this.getData({ cancel_current_api_call: true });
            }
        }
    },
    methods: {
        initiate() {
            this.getData();
        },
        getData(payload) {
            let { cancel_current_api_call } = payload || {};

            if (cancel_current_api_call) {
                this.$api.cancelCurrentApiCall();
            }

            this.dataTable.loading = true;

            const { search, itemLength, currentPage, sortBy, sortDesc } = this.dataTable;
            this.$store
                .dispatch('systemVariables/fetchSystemVariables', {
                    config: {
                        params: {
                            search: search || undefined,
                            per_page: itemLength,
                            page: currentPage,
                            sort_by: sortBy[0],
                            order: sortDesc[0] != undefined ? (!sortDesc[0] ? 'asc' : 'desc') : undefined
                        }
                    }
                })
                .then(() => {})
                .catch((error) => {
                    this.dataTable.loading = false;

                    if (error.response) {
                        this.$notify({
                            group: 'main-notifications',
                            type: 'error',
                            title: 'Audit Trails',
                            text: error.response.data?.message || error.response.statusText
                        });
                    }
                });
        },
        confirmAction({ action, data }) {
            // Set modal title starting sentence
            switch (action) {
                case 'delete':
                    data.modalTitle = 'Delete Merchant?';
                    data.modalDescription = 'Are you sure you want to delete this variable?';
                    break;
            }

            this.confirmDialog = { show: true, action, data };
        },
        action({ action, data }) {
            switch (action) {
                case 'add':
                    // get
                    this.contentManagementFormDialog = { show: true, action, data: {} };
                    break;
                case 'edit':
                    this.confirmDialog.show = false;
                    this.contentManagementFormDialog = { show: true, action, data };
                    break;
                case 'delete':
                    this.confirmDialog.loading = true;
                    this.deletePage(data);
                    break;
                default:
                    this.contentManagementFormDialog = { show: true, action, data: data || {} };
                    break;
            }
        },
        filterData() {
            this.getData({ cancel_current_api_call: true });
        },
        download() {
            // Download selected items
            console.log(this.dataTable.selected);
        },
        viewDetails(id) {
            // View Details
            console.log(id);
        },
        editDetails(id) {
            // Edit Details
            console.log(id);
        }
    },
    mounted() {
        this.initiate();
    }
};
</script>

<style lang="scss" scoped>
.merchant-empty {
    min-height: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
